// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"32":"6e097b52","299":"d22577cf","666":"11b2a187","807":"057679a1","936":"a11d9ca6"}[chunkId] + ".css";
};